import React from "react";
import { Link } from "react-router-dom";
import '../css/VerticalNavbar.css'; // Add this line for styling

const VerticalNavbar = () => {
  return (
    <nav className="vertical-navbar">
      <ul className="nav-links">
        <li><Link to="/login">Login</Link></li>
      </ul>
    </nav>
  );
};

export default VerticalNavbar;